import { render, staticRenderFns } from "./EditMunicipioPage.vue?vue&type=template&id=6e0b6826&"
import script from "./EditMunicipioPage.vue?vue&type=script&lang=js&"
export * from "./EditMunicipioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports